import React from 'react';
import { TrendingUp } from 'lucide-react';

/**
 * LotePromedios - Category averages section
 */
const LotePromedios = ({ lote }) => {
    if (!lote.promedio_min && !lote.promedio_max && !lote.promedio_prom) {
        return null;
    }

    return (
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-4 lg:p-6 mb-4 lg:mb-8">
            <h3 className="text-base lg:text-lg font-bold text-gray-900 mb-3 lg:mb-4 flex items-center gap-2">
                <TrendingUp className="w-4 h-4 lg:w-5 lg:h-5 text-green-600" />
                Promedios de la Categoría
            </h3>
            <div className="grid grid-cols-3 gap-2 lg:gap-4">
                <div className="bg-gray-50 p-4 rounded-xl text-center">
                    <p className="text-xs text-gray-500 font-semibold uppercase mb-1">Mínimo</p>
                    <p className="text-xl font-bold text-gray-900">${lote.promedio_min || '-'}</p>
                </div>
                <div className="bg-green-50 p-4 rounded-xl text-center border border-green-100">
                    <p className="text-xs text-green-700 font-semibold uppercase mb-1">Promedio</p>
                    <p className="text-2xl font-black text-green-600">${lote.promedio_prom || '-'}</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl text-center">
                    <p className="text-xs text-gray-500 font-semibold uppercase mb-1">Máximo</p>
                    <p className="text-xl font-bold text-gray-900">${lote.promedio_max || '-'}</p>
                </div>
            </div>
        </div>
    );
};

export default LotePromedios;
